import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { IconBack } from "../../icons/Icon";
import KitchenIndentDetails from "./KitchenIndentDetails";
import { useNavigate } from 'react-router-dom';
import { fetchMogs } from "../../services/kitchenIndentSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";

const KitchenIndent = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(fetchMogs({
      mogcode: "",
      searchtext: ""
    }));
  }, [])

  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        <button onClick={goBack} className="mr-10"><IconBack /></button>
        Kitchen Indent
      </h1>
      <KitchenIndentDetails />
    </div>
  );
};

export default KitchenIndent;
